import React from 'react'

export default function NotFound() {
  return (
    <>
        <div className="row skills m-3 mb-5" style={{backgroundColor:'var(--color-1)',borderRadius:'5px'}}>
            <h1 className='text-center my-4' style={{color:'var(--color-6)',fontWeight:'900',fontSize:'55px'}}>404 not found!</h1>
        </div>

    </>
  )
}
